document.addEventListener('change', (e) => {
  const select = e.target;
  if (!select.matches('select.hh-card-variant[name="id"]')) return;

  const form = select.closest('form');
  if (!form) return;

  const opt = select.options[select.selectedIndex];
  if (!opt) return;

  const price = opt.getAttribute('data-v-price');
  const compareAt = opt.getAttribute('data-v-compare-at');

  const priceEl = form.querySelector('span[data-price]');
  const compareEl = form.querySelector('span[data-compare-price]');

  // ✅ ne jamais vider le prix
  if (price && priceEl) priceEl.textContent = price;

  if (compareEl) {
    if (compareAt) {
      compareEl.textContent = compareAt;
      compareEl.classList.remove('is-hidden');
    } else {
      compareEl.classList.add('is-hidden');
    }
  }
});
